var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Compiler, Component, Injector, Input, } from '@angular/core';
import { Entity } from '@synisys/idm-de-core-frontend';
import { DePermissionService, } from '@synisys/idm-de-service-client-js';
import { FormService, FormType, } from '@synisys/idm-dynamic-layout-interpreter';
import { KbService } from '@synisys/idm-kb-service-client-js';
import { LanguageService } from '@synisys/idm-message-language-service-client-js';
import { ValidationService, } from '@synisys/idm-validation-calculation-service-client-js';
import { ActionService, } from '@synisys/idm-workflow-service-client-js';
import { Observable } from 'rxjs/Observable';
import { first, flatMap, map } from 'rxjs/operators';
import { noop } from 'rxjs/util/noop';
import { MetaFormHelperService } from '../../service/local/meta-form-helper.service';
import { DynamicFormLayout } from '../dynamic-form-layout';
import { DynamicLayoutType } from '../dynamic-layout';
import { DynamicFormComponent } from '../form';
var WorkflowFormComponent = /** @class */ (function (_super) {
    __extends(WorkflowFormComponent, _super);
    function WorkflowFormComponent(compiler, injector, validationService, formService, kbService, dePermissionService, languageService, actionService, metaFormHelperService) {
        var _this = _super.call(this) || this;
        _this.compiler = compiler;
        _this.injector = injector;
        _this.validationService = validationService;
        _this.formService = formService;
        _this.kbService = kbService;
        _this.dePermissionService = dePermissionService;
        _this.languageService = languageService;
        _this.actionService = actionService;
        _this.metaFormHelperService = metaFormHelperService;
        return _this;
    }
    Object.defineProperty(WorkflowFormComponent.prototype, "rootForm", {
        set: function (value) {
            this._rootForm = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowFormComponent.prototype, "metaForm", {
        get: function () {
            return this._metaForm;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowFormComponent.prototype, "thisRef", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    WorkflowFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isReady$ = Observable.fromPromise(this.actionService.getAction(this.actionId)).pipe(flatMap(function (action) {
            return _this.metaFormHelperService
                .loadFormMetaModel(_this.categoryName, _this.entity, _this.formKey, _this.formId, true, action.getTargetStateId())
                .pipe(map(function (metaForm) {
                _this._metaForm = metaForm;
                _this._countOfControls = _this.countNumberOfControls();
                return true;
            }, function (err) { return console.error(err); }), first());
        }));
        this.actionName$ = Observable.fromPromise(this.actionService.getAction(this.actionId)).pipe(map(function (action) {
            return action.getName().getValue(_this.currentLanguage.getId());
        }));
    };
    Object.defineProperty(WorkflowFormComponent.prototype, "currentLanguage", {
        get: function () {
            return this._rootForm.currentLanguage;
        },
        enumerable: true,
        configurable: true
    });
    WorkflowFormComponent.prototype.getCurrentLanguage = function () {
        return this._rootForm.currentLanguage;
    };
    WorkflowFormComponent.prototype.getLayoutActions = function () {
        return this._rootForm.layoutActions;
    };
    WorkflowFormComponent.prototype.isForm = function () {
        return true;
    };
    WorkflowFormComponent.prototype.getEntity = function () {
        return this.entity;
    };
    WorkflowFormComponent.prototype.getActionNotifier = function () {
        return this._rootForm.actionNotifier;
    };
    WorkflowFormComponent.prototype.doWorkflowAction = function () {
        this._rootForm.actions['doWorkflowWithoutCleaning'](this.actionId, this._rootForm).subscribe(noop, console.log);
    };
    WorkflowFormComponent.prototype.addRuntimeComponent = function (controlModel, moduleType, component, cellTitle, tabId) {
        var rootForm = this._rootForm;
        var item = this.entity;
        this._moduleSet.add(moduleType);
        var workflowActionId = this.actionId;
        var thisRef = this;
        /* tslint:disable:max-classes-per-file*/
        var cmpClass = /** @class */ (function () {
            function RuntimeComponent() {
                this.category = rootForm.getMetaForm().layoutModel.category;
                this.form = rootForm;
                this.queryParams = rootForm.queryParams;
                this.actions = rootForm.actions;
                this.languages = rootForm.languages;
                this.tabId = tabId;
                this.item = item;
                this.cellId = controlModel.id;
                this.controlId = controlModel.id;
                this.transientFields = rootForm.transientFields;
                this.actionNotifier = rootForm.actionNotifier;
                this.popupEditMode = rootForm.popupEditMode;
                this.contextCategory = this.category;
                this.layoutType = DynamicLayoutType.workflowForm;
                this.workflowActionId = workflowActionId;
                this.formType = FormType.EDIT;
                this.title = cellTitle;
                this.containerType = rootForm.containerType;
                this.isRequired = thisRef.isControllerRequiredToSet(controlModel);
            }
            Object.defineProperty(RuntimeComponent.prototype, "workflowActions", {
                get: function () {
                    return this.form.workflowActions;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RuntimeComponent.prototype, "entity", {
                get: function () {
                    return this.form.entity;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RuntimeComponent.prototype, "dePermissionModel", {
                get: function () {
                    return this.form.metaForm.dePermission;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RuntimeComponent.prototype, "contextEntity", {
                get: function () {
                    return rootForm.entity;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RuntimeComponent.prototype, "validations", {
                get: function () {
                    return this.form.getValidations();
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RuntimeComponent.prototype, "currentLanguageId", {
                get: function () {
                    return rootForm.currentLanguage.getId();
                },
                enumerable: true,
                configurable: true
            });
            return RuntimeComponent;
        }());
        Component(component)(cmpClass);
        this._componentCache.set(controlModel.id, cmpClass);
        if (this._componentCache.size === this._countOfControls) {
            this.loadRuntimeModule().subscribe(noop, console.error);
        }
    };
    WorkflowFormComponent.prototype.getPredicateContext = function () {
        return {
            entity: this._rootForm.entity,
            actions: this._rootForm.actions,
            item: this.entity,
            popupEditMode: this._rootForm.popupEditMode,
            queryParams: this._rootForm.queryParams,
            isEditForm: this._rootForm.metaForm.formType === FormType.EDIT,
        };
    };
    WorkflowFormComponent.prototype.getModuleRegistryService = function () {
        return this._rootForm.moduleRegistryService;
    };
    WorkflowFormComponent.prototype.getInitialTabId = function () {
        return undefined;
    };
    WorkflowFormComponent.prototype.getMetaForm = function () {
        return this.metaForm;
    };
    WorkflowFormComponent.prototype.dynamicLayoutType = function () {
        return DynamicLayoutType.workflowForm;
    };
    WorkflowFormComponent.prototype.getValidations = function () {
        return this._rootForm.getValidations();
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], WorkflowFormComponent.prototype, "id", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], WorkflowFormComponent.prototype, "formId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], WorkflowFormComponent.prototype, "formKey", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], WorkflowFormComponent.prototype, "categoryName", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Entity)
    ], WorkflowFormComponent.prototype, "entity", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], WorkflowFormComponent.prototype, "actionId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", DynamicFormComponent),
        __metadata("design:paramtypes", [DynamicFormComponent])
    ], WorkflowFormComponent.prototype, "rootForm", null);
    WorkflowFormComponent = __decorate([
        Component({
            moduleId: module.id + '',
            selector: 'dynamic-workflow-form',
            template: require('./workflow-form.component.html'),
            styles: [require('./workflow-form.component.css')],
        }),
        __metadata("design:paramtypes", [Compiler,
            Injector,
            ValidationService,
            FormService,
            KbService,
            DePermissionService,
            LanguageService,
            ActionService,
            MetaFormHelperService])
    ], WorkflowFormComponent);
    return WorkflowFormComponent;
}(DynamicFormLayout));
export { WorkflowFormComponent };
//# sourceMappingURL=workflow-form.component.js.map